import React, { Component } from "react";
import service from "../../core/service";
import { toast } from "react-toastify";
import * as yup from "yup";
import { fixNumbers } from "../../core/utils";

interface IProps {}

interface IState {
  value: string;
  image: any;
  imagePreview: any;
  files: any;
  msg: string;
  chatDetails: any;
  assignLoading: boolean;
  assignPersonsList: any;
  assgin_to_id: string;
  anchorEl: any;
  openTaskModal: boolean;
  to_date: any;
  subject: string;
  descriptions: string;
  errorTask: any;
  openAddToDealModal: boolean;
  member: any;
  membersList: any;
  leadsModelList: any;
  lead: any;
  openCompletionModal: boolean;
  completionData: any;
  endInsuranceModal: boolean;
  insuranceEndData: any;
  addEndDate: boolean;
  newCompletionData: any;
  endDate: string;
  insuranceTitle: string;
  productTitle: string;
  finalEndDate: string;
  productList: any;
  insuranceList: any;
  description: string;
  estimatePremium: string;
  openEditModal: boolean;
  stagesList: any;
  stage: any;
  changeLeadStateModal: boolean;

  statesList: any;
  state: any;

  dealStage: any;
  dealStagesList: any;
  dealStatesList: any;
  dealState: any;

  openChangeDealStateModal: boolean;
  openChangeDealStageModal: boolean;

  isAddingTask: boolean;
  isAssigningToDealModel: boolean;
  isEditingCompletion: boolean;
  isAddingEndDate: boolean;
  isChangingDealStage: boolean;
  isChangingDealState: boolean;
  isChangingLeadState: boolean;

  sendPlan: boolean;
  categoryList: any;
  category_id: any;
  person_name: any;
  mobile: any;
  sendPlanLoading: boolean;
  errorsList: any;
}

export class DetailsTicketController extends Component<IProps, IState> {
  datePickerRef: any;
  ref: any;
  msgInputRef: any;
  msgMobileInputRef: any;

  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
    this.datePickerRef = React.createRef();
    this.msgInputRef = React.createRef();
    this.msgMobileInputRef = React.createRef();
  }
  state: IState = {
    value: "",
    image: null,
    imagePreview: null,
    files: null,
    msg: "",
    chatDetails: [],
    assignPersonsList: [],
    assignLoading: false,
    assgin_to_id: "",
    anchorEl: null,
    openTaskModal: false,
    to_date: "",
    subject: "",
    descriptions: "",
    errorTask: [],
    openAddToDealModal: false,
    member: null,
    membersList: [],
    leadsModelList: [],
    lead: null,
    openCompletionModal: false,
    completionData: {},
    endInsuranceModal: false,
    insuranceEndData: [],
    addEndDate: false,
    newCompletionData: {},
    endDate: "",
    insuranceTitle: "",
    insuranceList: [],
    productList: "",
    productTitle: "",
    finalEndDate: "",
    description: "",
    estimatePremium: "",
    openEditModal: false,
    stagesList: [],
    stage: null,
    changeLeadStateModal: false,
    statesList: [],
    state: null,

    openChangeDealStateModal: false,
    openChangeDealStageModal: false,
    dealStage: null,
    dealStagesList: [],
    dealStatesList: [],
    dealState: null,

    isAddingTask: false,
    isAssigningToDealModel: false,
    isEditingCompletion: false,
    isAddingEndDate: false,
    isChangingDealStage: false,
    isChangingDealState: false,
    isChangingLeadState: false,
    sendPlan: false,
    categoryList: [],
    category_id: "",
    person_name: "",
    mobile: "",
    sendPlanLoading: false,
    errorsList: [],
  };
  handleChange = (e: any) => {
    this.setState({ value: e.target.value });
  };
  componentDidMount() {
    window.addEventListener("resize", this.syncMsgInputs);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.syncMsgInputs);
  }
  componentDidUpdate(_prevProps: IProps, prevState: IState) {
    if (prevState.msg !== this.state.msg) {
      this.syncMsgInputs();
    }
  }
  syncMsgInputs = () => {
    if (this.msgInputRef.current) {
      this.autoGrowMsgInput(this.msgInputRef.current);
    }
    if (this.msgMobileInputRef.current) {
      this.autoGrowMsgInput(this.msgMobileInputRef.current);
    }
  };
  autoGrowMsgInput = (el: any) => {
    if (!el || el.offsetParent === null) return;
    const style = window.getComputedStyle(el);
    const lineHeight = parseFloat(style.lineHeight) || 21;
    const padding =
      (parseFloat(style.paddingTop) || 0) +
      (parseFloat(style.paddingBottom) || 0);
    const composer = el.closest(".chat-composer");
    const row = el.closest(".chat-composer-row");

    // Decide single vs multiline at a FIXED (full) width with height:auto.
    // The set height must not affect the measurement: when the height was
    // set first, scrollHeight returned the previous layout, flipping the
    // decision back and forth while typing the start of line 2.
    if (composer && row) {
      const padLR =
        (parseFloat(style.paddingLeft) || 0) +
        (parseFloat(style.paddingRight) || 0);
      const prev = {
        width: el.style.width,
        flex: el.style.flex,
        height: el.style.height,
      };
      el.style.flex = "none";
      el.style.width = `${Math.max(row.clientWidth - padLR, 120)}px`;
      el.style.height = "auto";
      const fullWidthScroll = el.scrollHeight;
      el.style.flex = prev.flex;
      el.style.width = prev.width;
      el.style.height = prev.height;
      composer.classList.toggle(
        "is-multiline",
        fullWidthScroll > lineHeight + padding + 2,
      );
    }

    // Grow the input to fit its text at the CURRENT width.
    el.style.height = "auto";
    el.style.height = `${Math.min(Math.max(el.scrollHeight, 40), 160)}px`;
  };
  gotToTickets = () => {
    window.location.href = `/`;
  };
  uploadFiles = (event: any) => {
    const newFiles = Array.from(event.target.files);
    this.setState((prevState) => ({
      files: Array.isArray(prevState.files)
        ? [...prevState.files, ...newFiles]
        : [...newFiles],
    }));
  };

  removeFile = (index: number) => {
    const files = [...this.state.files];
    files.splice(index, 1);
    this.setState({ files });
  };
  getChatDetails = async () => {
    try {
      const response = await service.Ticket.details(
        window.location.pathname.split("/")[2],
      );
      if (response) {
        this.setState({
          chatDetails: response.data?.data,
          assignLoading: false,
        });
        this.handleChangePage();
      } else {
      }
    } catch (error) {
      // throw error;
    }
  };
  scrollTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = () => {
    clearTimeout(this.scrollTimeOut);
    this.scrollTimeOut = setTimeout(() => {
      this.ref.current?.lastElementChild?.scrollIntoView();
    }, 100);
  };

  sendAnswer = async () => {
    const { msg, chatDetails, files } = this.state;
    if (msg !== "") {
      try {
        const response = await service.Ticket.answer(
          msg,
          chatDetails.id,
          files,
        );
        if (response) {
          this.setState({ msg: "", files: [] });
          this.getChatDetails();
          toast.success("با موفقیت ارسال شد");
        } else {
        }
      } catch (error) {
        // throw error;
      }
    } else {
      toast.info("متن پیام نمیتواند خالی باشد");
    }
  };
  getAssignPersonsList = async () => {
    try {
      const response = await service.Ticket.assignPersonsList();
      if (response) {
        this.setState({
          assignPersonsList: response?.data?.data?.list,
        });

        // return response;
      } else {
      }
    } catch (error) {
      // throw error;
    }
  };

  async assignTo(assgin_to_id: string) {
    this.setState({ assignLoading: true, assgin_to_id: assgin_to_id });
    try {
      const response = await service.Ticket.assignTo(
        window.location.pathname.split("/")[2],
        assgin_to_id,
      );
      if (response) {
        toast.success(response?.data?.message);
        this.getChatDetails();
      } else {
        this.setState({ assignLoading: false });
      }
    } catch (error) {
      // throw error;
    }
  }

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
      openTaskModal: false,
      to_date: "",
      subject: "",
      descriptions: "",
      errorTask: [],
    });
  };
  handleChangeDate = (value: any) => {
    this.setState({ to_date: value });
  };

  async addTask() {
    const { to_date, subject, descriptions } = this.state;
    this.setState({ isAddingTask: true });
    const schema = yup.object({
      subject: yup.string().required("عنوان  اجباری می باشد"),
      descriptions: yup.string().required("توضیحات اجباری می باشد"),
      to_date: yup.string().required(" تاریخ اجباری می باشد"),
    });
    try {
      // this.setState({ loading: true })
      await schema.validate(
        { to_date, subject, descriptions },
        { abortEarly: false },
      );
      const response = await service.Calender.create(
        fixNumbers(to_date?.format()),
        subject,
        descriptions,
        window.location.pathname.split("/")[2],
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            openTaskModal: false,
            to_date: "",
            subject: "",
            descriptions: "",
          });
          // this.setState({ loading: false })
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      } else {
        this.setState({
          errorTask: [],
          openTaskModal: false,
          to_date: "",
          subject: "",
          descriptions: "",
        });
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
      // this.setState({ loading: false })
    } finally {
      this.setState({ isAddingTask: false });
    }
  }
  handleOpenAddLeadModal = () => {
    this.setState({ openAddToDealModal: true });
    this.getMembersList();
    this.getLeadsModelList();
  };
  handleDealChange = (e: any) => {
    this.setState({ lead: e.target.value });
    this.getStagesListWithDealId(e.target.value);
  };
  getLeadsModelList = async () => {
    try {
      const response = await service.Deals.modelList();
      if (response) {
        if (response.status === 200) {
          this.setState({ leadsModelList: response?.data?.data?.list });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error) {}
  };
  getMembersList = async () => {
    try {
      const response = await service.LeadsMember.list();
      if (response) {
        if (response.status === 200) {
          this.setState({ membersList: response?.data?.data?.list });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error) {}
  };
  async handleSendDealModel() {
    const { lead, member, description, estimatePremium, stage } = this.state;
    this.setState({ isAssigningToDealModel: true });
    const schema = yup.object({
      lead: yup
        .number()
        .typeError("انتخاب مدل معاملاتی الزامی می‌باشد")
        .required(" انتخاب مدل معامله الزامی می‌باشد"),
      member: yup
        .number()
        .typeError("انتخاب مسُول الزامی می‌باشد")
        .required(" انتخاب  مسُول الزامی می‌باشد"),
      stage: yup
        .number()
        .typeError("انتخاب مرحله الزامی می‌باشد")
        .required(" انتخاب  مرحله الزامی می‌باشد"),
    });
    try {
      await schema.validate({ lead, member, stage }, { abortEarly: false });
      const response = await service.Ticket.assignToDealModel(
        member,
        lead,
        window.location.pathname.split("/")[2],
        estimatePremium !== "" ? estimatePremium : "0",
        description !== "" ? description : "-",
        stage,
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            openAddToDealModal: false,
            description: "",
            estimatePremium: "",
            member: null,
            lead: null,
            stage: "",
          });
          this.getChatDetails();
          this.getAssignPersonsList();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
    } finally {
      this.setState({ isAssigningToDealModel: false });
    }
  }
  handleCompletion = () => {
    const { openCompletionModal } = this.state;
    this.setState({
      openCompletionModal: !openCompletionModal,
      anchorEl: null,
    });
    this.getCompletionData();
    this.getEndInsuranceData();
  };
  getCompletionData = async () => {
    try {
      const response = await service.Ticket.getCompletion(
        window.location.pathname.split("/")[2],
      );
      if (response) {
        if (response.status === 200) {
          this.setState({ completionData: response?.data?.data });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
    }
  };
  handleEndInsuranceModal = async () => {
    this.setState({ endInsuranceModal: true });
    this.getEndInsuranceData();
    this.getInsurancesList();
    this.getProductsList();
  };
  handleBackFromAddEndDate = () => {
    this.setState({
      addEndDate: false,
      insuranceTitle: "",
      endDate: "",
      finalEndDate: "",
      productTitle: "",
      errorTask: [],
    });
  };
  getInsurancesList = async () => {
    try {
      const response = await service.Insurance.list();
      if (response) {
        if (response.status === 200) {
          this.setState({ insuranceList: response?.data?.data?.list });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
    }
  };
  getProductsList = async () => {
    try {
      const response = await service.Products.list();
      if (response) {
        if (response.status === 200) {
          this.setState({ productList: response?.data?.data?.list });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
    }
  };
  getEndInsuranceData = async () => {
    try {
      const response = await service.Ticket.getInsuranceEndTime(
        window.location.pathname.split("/")[2],
      );
      if (response) {
        if (response.status === 200) {
          this.setState({ insuranceEndData: response?.data?.data });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
    }
  };
  handleChangeCompletionData = (key: string, value: string) => {
    const { completionData, newCompletionData } = this.state;
    completionData[key].value = value;
    this.setState({
      completionData,
      newCompletionData: { ...newCompletionData, [key]: value },
    });
  };
  async changeState() {
    const { state, chatDetails } = this.state;
    this.setState({ isChangingLeadState: true });
    const schema = yup.object({
      state: yup.string().required(" وضعیت اجباری می‌باشد"),
    });
    try {
      await schema.validate({ state }, { abortEarly: false });
      const response = await service.Leads.updateState(
        chatDetails?.lead_id,
        parseInt(state),
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            changeLeadStateModal: false,
            state: "",
          });
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
          this.setState({
            errorTask: [],
            changeLeadStateModal: false,
            state: "",
          });
        }
      } else {
        this.setState({
          errorTask: [],
          changeLeadStateModal: false,
          state: "",
        });
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
    } finally {
      this.setState({ isChangingLeadState: false });
    }
  }
  handleEditCompletion = async () => {
    const { newCompletionData } = this.state;
    this.setState({ isEditingCompletion: true });
    try {
      const response = await service.Ticket.editCompletion(
        window.location.pathname.split("/")[2],
        newCompletionData,
      );
      if (response) {
        if (response.status === 200) {
          this.getCompletionData();
          toast.success(response.data.message);
          this.setState({ openCompletionModal: false, insuranceEndData: [] });
        } else {
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
      this.setState({ errorTask: error.inner });
    } finally {
      this.setState({ isEditingCompletion: false });
    }
  };
  handleChangeEndDate = (value: any) => {
    if (!value) {
      this.setState({ endDate: "", finalEndDate: "" });
      return;
    }

    const formatted =
      typeof value?.format === "function"
        ? fixNumbers(value.format("YYYY/MM/DD"))
        : fixNumbers(String(value));
    const digits = formatted.replace(/\D/g, "");

    this.setState({
      endDate: value,
      finalEndDate: digits.length === 8 ? formatted : "",
    });
  };
  async addEndDate() {
    const { insuranceTitle, productTitle, finalEndDate } = this.state;
    this.setState({ isAddingEndDate: true });
    const schema = yup.object({
      insuranceTitle: yup.string().required("عنوان بیمه الزامی می‌یاشد"),
      endDate: yup
        .string()
        .matches(/^\d{4}\/\d{2}\/\d{2}$/, "فرمت تاریخ باید YYYY/MM/DD باشد")
        .required(" انتخاب اتمام زمان بیمه الزامی می‌یاشد"),
    });
    try {
      await schema.validate(
        { insuranceTitle, productTitle, endDate: finalEndDate },
        { abortEarly: false },
      );
      const response = await service.Ticket.addInsuranceEndTime(
        finalEndDate,
        insuranceTitle,
        productTitle !== "" ? productTitle : "بیمه تکمیلی",
        window.location.pathname.split("/")[2],
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            addEndDate: false,
            insuranceTitle: "",
            productTitle: "",
            endDate: "",
            finalEndDate: "",
          });
          this.getEndInsuranceData();
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
    } finally {
      this.setState({ isAddingEndDate: false });
    }
  }

  handleChangeLeadState = () => {
    this.setState({ changeLeadStateModal: true });
    this.getStatesList();
  };
  getStatesList = async () => {
    try {
      const response = await service.Leads.states();
      if (response) {
        this.setState({ statesList: response?.data?.data?.list });
      } else {
        toast.error("مشکلی پیش آمده");
      }
    } catch (error) {}
  };
  async getStagesListWithDealId(e: any) {
    const response = await service.Stage.listWithDealId(e);
    if (response) {
      if (response.status === 200) {
        this.setState({
          stagesList: response?.data?.data?.list,
        });
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      this.setState({ openEditModal: false });
      toast.error("مشکلی پیش آمده‌است");
    }
  }
  handleOpenDealStageModal = () => {
    this.setState({ openChangeDealStageModal: true });
    this.getStagesList();
  };
  handleOpenDealStateModal = () => {
    this.setState({ openChangeDealStateModal: true });
    this.getDealStatesList();
  };
  async handleSendDealState() {
    const { dealState, chatDetails } = this.state;
    this.setState({ isChangingDealState: true });
    const schema = yup.object({
      dealState: yup.string().required(" انتخاب وضعیت اجباری می‌باشد"),
    });
    try {
      await schema.validate({ dealState }, { abortEarly: false });
      const response = await service.Deals.changeState(
        dealState,
        chatDetails?.deal_id,
        chatDetails?.deal_data_id,
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            openChangeDealStateModal: false,
            dealState: "",
          });
          this.getChatDetails();
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      } else {
        this.setState({ openChangeDealStateModal: false });
        toast.success("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
    } finally {
      this.setState({ isChangingDealState: false });
    }
  }
  async getDealStatesList() {
    const response = await service.Deals.statesList();
    if (response) {
      if (response.status === 200) {
        this.setState({
          dealStatesList: response?.data?.data?.list,
        });
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      toast.error("مشکلی پیش آمده‌است");
    }
  }
  async getStagesList() {
    const { chatDetails } = this.state;
    const response = await service.Stage.listWithDealId(chatDetails?.deal_id);
    if (response) {
      if (response.status === 200) {
        this.setState({
          dealStagesList: response?.data?.data?.list,
        });
      } else {
        toast.error("مشکلی پیش آمده‌است");
      }
    } else {
      this.setState({ openEditModal: false });
      toast.error("مشکلی پیش آمده‌است");
    }
  }

  async handleChangeStage() {
    const { dealStage, chatDetails } = this.state;
    this.setState({ isChangingDealStage: true });
    const schema = yup.object({
      dealStage: yup.string().required(" انتخاب مرحله اجباری می‌باشد"),
    });
    try {
      await schema.validate({ dealStage }, { abortEarly: false });
      const response = await service.Deals.changeStage(
        dealStage,
        chatDetails?.deal_id,
        chatDetails?.deal_data_id,
      );
      if (response) {
        if (response?.status === 200) {
          this.setState({
            errorTask: [],
            openChangeDealStageModal: false,
            dealStage: "",
          });
          this.getChatDetails();
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      } else {
        this.setState({ openChangeDealStageModal: false });
        toast.success("مشکلی پیش آمده‌است");
      }
    } catch (err: any) {
      this.setState({ errorTask: err.inner });
    } finally {
      this.setState({ isChangingDealStage: false });
    }
  }
  getCategoryList = async () => {
    try {
      const response = await service.Doc.doc();
      if (response) {
        this.setState({ categoryList: response?.data?.data?.list });
      } else {
      }
    } catch (error) {}
  };
  handleOpenPlanModal = () => {
    this.setState({ sendPlan: true });
  };
  async sendPlan() {
    this.setState({ sendPlanLoading: true });
    const { mobile, person_name, category_id } = this.state;
    const schema = yup.object({
      mobile: yup.string().required("شماره موبایل اجباری می باشد"),
      person_name: yup.string().required("نام اجباری می باشد"),
      category_id: yup.string().required("دسته بندی اجباری می باشد"),
    });
    try {
      await schema.validate(
        { mobile, person_name, category_id },
        { abortEarly: false },
      );
      const response = await service.Doc.create({
        mobile,
        person_name,
        category_id,
        ticket_id: window.location.pathname.split("/")[2],
      });

      if (response) {
        if (response?.status === 200) {
          this.setState({
            sendPlan: false,
            errorsList: [],
            sendPlanLoading: false,
            mobile: "",
            person_name: "",
            category_id: "",
          });
          toast.success(response?.data?.message);
        }
      } else {
        this.setState({ sendPlanLoading: false });
      }
    } catch (err: any) {
      this.setState({ errorsList: err.inner });
    } finally {
      this.setState({ sendPlanLoading: false });
    }
  }
}
export default DetailsTicketController;
